import React from 'react';
import FieldOptionsTab from './FieldOptionsTab';

const ManageStatusTab = (props) => (
  <FieldOptionsTab
    title="Manage Status"
    description='Manage fields and their options (e.g. "Body Type" → Slim, Average, Athletic)'
    emptyMessage='No status fields yet. Click "Add Field" to create one.'
    fieldPlaceholder='e.g. "Body Type", "Height", "Age"'
    optionPlaceholder='e.g. "Average", "Slim", "Single"'
    saveErrorMessage="Failed to save manage status"
    activityPrefix="status"
    {...props}
  />
);

export default ManageStatusTab;
